import React, { useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor, EuiForm, EuiSwitch} from '@elastic/eui';
import {SelectorVehiculosContainer as SelectorVehiculos} from '../../../../components/Selectores/Vehiculos/container';
//import { ComboSubFuncionesContainer as ComboSubFunciones} from '../../../components/Combos/SubFunciones/container';
//import { createOptions } from '../../../components/Combos/SubFunciones/functions';

export const Formulario = (props)=>{

  let {onSave, selected, onClose} = props
  let [vehiculo,setVehiculo] = useState(selected ? selected.vehiculo : undefined);
  let [auxiliar, setAuxiliar] = useState(selected ? selected.auxiliar : undefined);
  let [activo, setActivo] = useState(selected ? selected.activo : true);
  let [codigo, setCodigo] = useState(selected ? selected.codigo : undefined);
  let [comentario, setComentario] = useState(selected ? selected.comentario : undefined);

  const getData = () =>{
    let data = { vehiculo: vehiculo, auxiliar: auxiliar, activo: activo, codigo: codigo, comentario: comentario}
    if(selected){
      return {...selected,...data}
    }else{
      return data
    }
  }

  const onSaveData = () =>{
    if(!comprobarErrores()){
      let newData = getData();
      onSave && onSave(newData)
    }
  }

  const comprobarErrores = () => {
    return (isInvalidVehiculo || isInvalidAuxiliar || isInvalidCodigo)
  }

  const isInvalidVehiculo = useMemo(() => {return vehiculo===undefined},[vehiculo])
  const isInvalidAuxiliar = useMemo(() => {return auxiliar===undefined || auxiliar.trim()===""},[auxiliar])
  const isInvalidCodigo = useMemo(() => {return codigo===undefined || (codigo??"").trim()===""},[codigo])


  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Vehiculo" isInvalid={isInvalidVehiculo}>
          <SelectorVehiculos fullWidth valueOfSelected={vehiculo} onChange={value => setVehiculo(value)} isInvalid={isInvalidVehiculo}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Auxiliar" isInvalid={isInvalidAuxiliar}>
          <EuiFieldText fullWidth value={auxiliar} name="txtAuxiliar" onChange={e => setAuxiliar(e.target.value)} isInvalid={isInvalidAuxiliar}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Código" isInvalid={isInvalidCodigo}>
          <EuiFieldText fullWidth value={codigo} name="txtCodigo" onChange={e => setCodigo(e.target.value)} isInvalid={isInvalidCodigo}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow>
          <EuiSwitch label={'Activo'} checked={activo} onChange={(e)=>setActivo(!activo)} />
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
          <EuiFlexItem>
            <EuiFormRow fullWidth label="Comentario">
              <EuiFieldText fullWidth value={comentario} name="txtComentario" onChange={e => setComentario(e.target.value)}/>
            </EuiFormRow>
          </EuiFlexItem>
    </EuiFlexGroup>
    {comprobarErrores() ? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{"Faltan campos por rellenar"}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="m" />

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
      
  )
}
export default Formulario;